import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useNonUserCartStore = create(
  persist(
    (set, get) => ({
      cartItems: [],
      totalItems: 0,
      loading: false,
      error: null,

      // Fetch cart from local storage (hydrated by Zustand)
      fetchCart: async () => {
        try {
          set({ loading: true });
          const items = get().cartItems || [];
          set({
            cartItems: items,
            totalItems: items.length,
            loading: false,
            error: null,
          });
        } catch (err) {
          console.error("Fetch cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      // Add item to local cart
      addToCart: async (asset) => {
        console.log("Adding to cart:", asset);
        try {
          set({ loading: true });
          const currentItems = get().cartItems || [];

          // Check if asset already exists
          const existingItem = currentItems.find(
            (item) => item.asset?._id === asset._id
          );

          let updatedItems;

          if (existingItem) {
            // Increment quantity if already exists
            updatedItems = currentItems.map((item) =>
              item.asset?._id === asset._id
                ? { ...item, quantity: item.quantity + 1 }
                : item
            );
          } else {
            // Add new item
            const newItem = {
              _id: "1234", // unique local id
              asset,
              quantity: 1,
            };
            updatedItems = [...currentItems, newItem];
          }

          set({
            cartItems: updatedItems,
            totalItems: updatedItems.length,
            loading: false,
            error: null,
          });
        } catch (err) {
          console.error("Add to cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      // Remove item from cart
      removeFromCart: async (assetId) => {
        try {
          set({ loading: true });
          const filtered = get().cartItems.filter(
            (item) => item.asset?._id !== assetId
          );
          set({
            cartItems: filtered,
            totalItems: filtered.length,
            loading: false,
            error: null,
          });
        } catch (err) {
          console.error("Remove from cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      // Clear cart
      clearCart: async () => {
        try {
          set({ loading: true });
          set({
            cartItems: [],
            totalItems: 0,
            loading: false,
            error: null,
          });
        } catch (err) {
          console.error("Clear cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      // Get total item count
      fetchCartCount: async () => {
        try {
          const count = get().cartItems.length;
          set({ totalItems: count });
        } catch (err) {
          console.error("Fetch cart count error:", err);
        }
      },
    }),
    {
      name: "cart-storage",
      partialize: (state) => ({
        cartItems: state.cartItems,
        totalItems: state.totalItems,
      }),
    }
  )
);
